import React from "react";
import { MenuItem } from "../types";
import { HomePageIcon }from "../icons/menu/home";
import { EventsPageIcon } from "../icons/menu/events";
import { TasksPageIcon } from "../icons/menu/tasks";
import { CustomersPageIcon } from "../icons/menu/customers";
import { AlalitycsPageIcon } from "../icons/menu/analitics";
import { UsersPageIcon } from "../icons/menu/users";
import { RightsPageIcon } from "../icons/menu/accessRights";

/* 
1	1	"Просмотр событий группы"
2	1	"Просмотр всех событий"
3	1	"Назначение ответственных по событиям группы"
4	1	"Назначение ответственных по всем событиям"
5	2	"Просмотр задач группы"
6	2	"Просмотр всех задач"
7	2	"Редактирование задач группы"
8	2	"Редактирование всех задач"
9	2	"Создание задач"
10	3	"Просмотр клиентов группы"
11	3	"Просмотр всех клиентов"
12	3	"Создание клиентов"
13	3	"Редактирование клиентов группы"
14	3	"Редактирование всех клиентов"
15	3	"Редактирование источников клиентов"
16	3	"Установление плана продаж внутри группы"
17	3	"Установление плана продаж для группы"
18	6	"Создание и удаление приглашений для своей группы"
19	4	"Просмотр аналитики группы"
20	4	"Просмотр аналитики всей"
21	5	"Просмотр профилей пользователей в группе"
22	5	"Добавление пользователей"
23	5	"Блокирование пользователей"
24	6	"Создание и редактирование групп пользователей"
25	6	"Создание и удаление приглашений по всем группам"
26	7	"Создание и редактирование ролей"
*/

export const menuIconProps = {
    width: 24,
    height: 24
}

export const breadcrumbsContent: MenuItem[] = [
    {
        url: "/",
        name: "Группы"
    },
    {
        url: "/",
        name: "Список групп"
    },
    {
        url: "/",
        name: "Страница 1"
    }
]

export const mainMenu: MenuItem[] = [
    {
        url: "/",
        name: "Домашняя страница",
        icon: <HomePageIcon width={menuIconProps.width} height={menuIconProps.height} />
    },
    {
        url: "/events/1",
        name: "События",
        icon: <EventsPageIcon width={menuIconProps.width} height={menuIconProps.height} />
    },
    {
        url: "/tasks/1",
        name: "Задачи",
        icon: <TasksPageIcon width={menuIconProps.width} height={menuIconProps.height} />
    },
    {
        url: "/clients/1",
        name: "Клиенты",
        icon: <CustomersPageIcon width={menuIconProps.width} height={menuIconProps.height} />,
        submenu: [{
            name: "Источники",
            url: "/clients/sources"
        }]
    },
    {
        url: "/analytics",
        name: "Аналитика",
        icon: <AlalitycsPageIcon width={menuIconProps.width} height={menuIconProps.height} />,
        submenu: [
            {
                name: "План продаж",
                url: "/analytics/salesplan"
            },
            {
                name: "План групповой",
                url: "/analytics/groupsplan"
            },
            {
                name: "Воронка продаж",
                url: "/analytics/salesfunnel"
            },
            /* {
                name: "Рейтинги",
                url: "/analytics/officerating"
            },  */
            {
                name: "Сотрудники",
                url: "/analytics/peoplerating"
            }
        ]
    },
    {
        url: "/users/1",
        name: "Пользователи",
        icon: <UsersPageIcon width={menuIconProps.width} height={menuIconProps.height} />,
        submenu: [{
            name: "Приглашения",
            url: "/users/invites"
        }]
    },
    {
        url: "/groups/1",
        name: "Группы пользователей",
        icon: <RightsPageIcon width={menuIconProps.width} height={menuIconProps.height} />
    },
    {
        url: "/roles/1",
        name: "Настройки ролей",
        icon: <RightsPageIcon width={menuIconProps.width} height={menuIconProps.height} />
    }
];